<template>
    <el-card class="box-card" v-loading="dataLoading">
        <div slot="header" class="clearfix">
            <span>
                <span class="el-icon-data-analysis"></span> 演出销售排行
            </span>
        </div>
        <div v-if="data" class="content">
            <el-row :gutter="20">
                <el-col :sm="12" :lg="6">
                    <el-card shadow="never">
                        <div slot="header" class="clearfix">
                            <div class="group-title">
                                单场演出
                                <router-link class="color-theme" :to="`/report/sales/show?timeStart=${intervalData.startTime} 00:00:00&timeEnd=${intervalData.endTime} 23:59:59`">(详情)</router-link>
                            </div>
                        </div>
                        <div class="rank">
                            <div v-for="(item,index) in data.activitySalesRankList" :key="index" class="item">
                                <span class="num" :class="`top-num-${index}`">{{index + 1}}</span>
                                <div class="info">
                                    <el-tooltip class="title" :content="item.name" placement="top">
                                        <span class="ellipsis">{{item.name}}</span>
                                    </el-tooltip>
                                    <div class="amount">销售额: {{item.amount}}</div>
                                </div>
                            </div>
                        </div>
                    </el-card>
                </el-col>
                <el-col :sm="12" :lg="6">
                    <el-card shadow="never">
                        <div slot="header" class="clearfix">
                            <div class="group-title">
                                巡演
                                <router-link class="color-theme" :to="`/report/sales/touring?timeStartStr=${intervalData.startTime} 00:00:00&timeEndStr=${intervalData.endTime} 23:59:59`">(详情)</router-link>
                            </div>
                        </div>
                        <div class="rank">
                            <div v-for="(item,index) in data.tourSalesRankList" :key="index" class="item">
                                <span class="num" :class="`top-num-${index}`">{{index + 1}}</span>
                                <div class="info">
                                    <el-tooltip class="title" :content="item.name" placement="top">
                                        <span class="ellipsis">{{item.name}}</span>
                                    </el-tooltip>
                                    <div class="amount">销售额: {{item.amount}}</div>
                                </div>
                            </div>
                        </div>
                    </el-card>
                </el-col>
                <el-col :lg="12" >
                    <div class="chart-box">
                        <div class="group-title">城市柱状图 <router-link class="color-theme" :to="`/report/sales/city?timeStart=${intervalData.startTime} 00:00:00&timeEnd=${intervalData.endTime} 23:59:59`">(详情)</router-link></div>
                        <div id="rankChart1" ref="rankChart1"></div>
                        <div class="group-title">艺人柱状图 <router-link class="color-theme" :to="`/report/sales/artist?timeStart=${intervalData.startTime} 00:00:00&timeEnd=${intervalData.endTime} 23:59:59`">(详情)</router-link></div>
                        <div id="rankChart2" ref="rankChart2"></div>
                        <div class="group-title">场地柱状图 <router-link class="color-theme" :to="`/report/sales/site?timeStart=${intervalData.startTime} 00:00:00&timeEnd=${intervalData.endTime} 23:59:59`">(详情)</router-link></div>
                        <div id="rankChart3" ref="rankChart3"></div>
                    </div>
                </el-col>
            </el-row>
        </div>
    </el-card>
</template>

<script>
import { Chart } from '@antv/g2';
export default {
    props:{
        intervalData:{
            type: Object,
            default: () => null
        },
        daterange:{
            type: Array,
            default: () => []
        }
    },
    data(){
        return{
            dataLoading: false,
            data: null,
            chart1: null,
            chart2: null,
            chart3: null,
        }
    },
    mounted(){
        this.getData();
    },
    watch:{
        intervalData(v1,v2){
            if(v1 && v1 != v2){
                this.getData();
            }
        }
    },
    methods:{
        getData(){
            this.dataLoading = true;
            this.$request({
                url: "/dashboard/salesRank",
                method: "POST",
                data: {
                    timeInterval: this.intervalData.timeInterval || "",
                    start: this.daterange.length > 0 ? this.daterange[0]: "",
                    end: this.daterange.length > 1 ? this.daterange[1]: "",
                }
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result || null;

                        this.$nextTick(() => {
                            this.drawChart1();
                            this.drawChart2();
                            this.drawChart3();
                        })
                        
                    } else {
                        this.data = null;
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.data = null;
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        drawChart1(){
            if( this.chart1 ) this.chart1.destroy();
            let _data = this.data.citySalesRankList ? [...this.data.citySalesRankList] : [];
            _data.map( v => {
                v.amount = parseFloat(v.amount);
            })
            this.chart1 = new Chart({
                container: 'rankChart1',
                autoFit: true,
                height: 120,
            });
            this.chart1.data(_data);
            this.chart1.interaction('active-region');    

            this.chart1.tooltip({
                showTitle: false,
                showMarkers: false,
            });
            this.chart1
                .interval()
                .position('name*amount')
                .size(30)
                .tooltip('name*amount', (name, amount) => {
                    amount = parseFloat(amount).toFixed(2);
                    return {
                        name: name,
                        value: amount,
                    };
                });
            this.chart1.render();
        },
        drawChart2(){
            if( this.chart2 ) this.chart2.destroy();
            let _data = this.data.artistSalesRankList ? [...this.data.artistSalesRankList] : [];
            _data.map( v => {
                v.amount = parseFloat(v.amount);
            })
            this.chart2 = new Chart({
                container: 'rankChart2',
                autoFit: true,
                height: 120,
            });
            this.chart2.data(_data);
            this.chart2.interaction('active-region');    

            this.chart2.tooltip({
                showTitle: false,
                showMarkers: false,
            });
            this.chart2
                .interval()
                .position('name*amount')
                .color('#9AD681')
                .size(30)
                .tooltip('name*amount', (name, amount) => {
                    amount = parseFloat(amount).toFixed(2);
                    return {
                        name: name,
                        value: amount,
                    };
                });
            this.chart2.render();
        },
        drawChart3(){
            if( this.chart3 ) this.chart3.destroy();
            let _data = this.data.siteSalesRankList ? [...this.data.siteSalesRankList] : [];
            _data.map( v => {
                v.amount = parseFloat(v.amount);
            })
            this.chart3 = new Chart({
                container: 'rankChart3',
                autoFit: true,
                height: 120,
            });
            this.chart3.data(_data);
            this.chart3.interaction('active-region');    

            this.chart3.tooltip({
                showTitle: false,
                showMarkers: false,
            });
            
            this.chart3
                .interval()
                .position('name*amount')
                .color('#FED46B')
                .size(30)
                .tooltip('name*amount', (name, amount) => {
                    amount = parseFloat(amount).toFixed(2);
                    return {
                        name: name,
                        value: amount,
                    };
                });
            this.chart3.render();
        }
    }
}
</script>

<style lang="scss" scoped>
.content{
    .rank{
        height: 410px;
        .item{
            overflow: hidden;
            margin: 44px 0;
            .num{
                width: 32px;
                height: 32px;
                line-height: 32px;
                border-radius: 50%;
                background-color: #f8f8f8;
                text-align: center;
                margin-right: 10px;
                float: left;
                font-size: 15px;
                font-weight: 700;
                &.top-num-0{
                    background-color: $--color-danger;
                    color: #fff;
                }
                &.top-num-1{
                    background-color: $--color-warning;
                    color: #fff;
                }
                &.top-num-2{
                    background-color: $--color-info;
                    color: #fff;
                }
            }
            .info{
                overflow: hidden;
                .title{
                    font-size: 14px;
                }
                .amount{
                    color: $--color-info;
                }
            }
        }
    }
    .chart-box{
        .group-title{
            font-size: 16px;
            margin: 20px 0;
        }
    }
}
</style>